<template>
    <div>
        <ul class="mb-4 flex flex-wrap border-b border-gray-200" role="tablist">
            <li
                v-for="(tab, index) in tabs"
                :key="index"
                class="-mb-px"
            >
                <a
                    :href="tabHref(index)"
                    role="tab"
                    class="mr-1 block rounded-t px-3 py-2 text-sm no-underline"
                    :class="index === activeIndex
                        ? 'border border-b-white border-gray-200 bg-white text-nav-active shadow-[0_-2px_3px_rgba(0,0,0,0.05)]'
                        : 'border border-transparent text-nav-muted hover:text-nav-active'"
                    @click="onTabClick($event, index)"
                >
                    <span v-if="isHtml(tab)" v-html="tab.tabTitle || tab.title"></span>
                    <span v-else>{{ tab.tabTitle || tab.title }}</span>
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BTabs',
    props: {
        value: {
            type: Number,
            default: undefined
        }
    },
    data () {
        return {
            tabs: [],
            activeIndex: typeof this.value === 'number' ? this.value : 0
        }
    },
    watch: {
        value (index) {
            if (typeof index === 'number' && index !== this.activeIndex) {
                this.activeIndex = index
                this.syncActive()
            }
        }
    },
    methods: {
        registerTab (tab) {
            this.tabs.push(tab)
            if (typeof this.value === 'number') {
                this.activeIndex = this.value
            } else if (tab.active) {
                this.activeIndex = this.tabs.length - 1
            }
            this.syncActive()
        },
        unregisterTab (tab) {
            const idx = this.tabs.indexOf(tab)
            if (idx !== -1) {
                this.tabs.splice(idx, 1)
                if (this.activeIndex >= this.tabs.length) {
                    this.activeIndex = Math.max(0, this.tabs.length - 1)
                }
                this.syncActive()
            }
        },
        onTabClick (event, index) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
                return
            }
            event.preventDefault()
            this.select(index)
        },
        select (index) {
            if (index === this.activeIndex) return
            this.activeIndex = index
            this.syncActive()
            this.$emit('change', index)
            this.$emit('input', index)
        },
        syncActive () {
            this.tabs.forEach((tab, i) => {
                tab.isActive = i === this.activeIndex
            })
        },
        tabHref (index) {
            const tab = this.tabs[index]
            const query = Object.assign({}, this.$route && this.$route.query ? this.$route.query : {})
            if (tab && (tab.hrefKey || tab.tabKey)) {
                query.tab = tab.hrefKey || tab.tabKey
            }
            if (this.$router) {
                return this.$router.resolve({ path: '/', query }).href
            }
            const search = new URLSearchParams(query).toString()
            return search ? `/?${search}` : '/'
        },
        isHtml (tab) {
            return !!(tab.isHtmlTitle || tab.htmlTitle)
        }
    },
    mounted () {
        this.$nextTick(() => {
            if (typeof this.value === 'number') {
                this.activeIndex = this.value
            } else {
                const initial = this.tabs.findIndex(t => t.active)
                if (initial >= 0) {
                    this.activeIndex = initial
                }
            }
            this.syncActive()
        })
    }
}
</script>
